<template>
  <div class="wrapper-slider">
    <swiper ref="mySwiper" v-bind:options="swiperOptions">
      <swiper-slide v-for="(item, index) in datalist" v-bind:key="index">
        <a :href="item.linkTo" :target="item.newWindows ? '_blank' : '_self'">
          <img class="swiper-img" :src="item.url" alt="" />
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
export default {
  name: "VerticalSlider",
  props: { datalist: Array, cycleTime: { type: Number, default: 3000 } },
  data() {
    return {
      swiperOptions: {
        loop: true, //循环
        slidesPerView: 3, //显示3个
        slidesPerGroup: 3, //3组一个
        direction: "vertical",
        loopedSlides: this.datalist.length, //循环的长度
        // centeredSlides: true, //居中显示
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        autoplay: {
          delay: this.cycleTime,
        },
      },
    };
  },
  mounted() {},
  methods: {},
  watch: {},
  beforeDestroy() {},
};
</script>

<style scoped>
.wrapper-slider {
  width: inherit;
  height: inherit;
}
.swiper-img {
  background-size: 100% 100%;
  height: 100%;
  object-fit: contain;
}
/* .swiper-container {
  width: 100%;
  height: 750px;
} */
.swiper-container {
  width: 750px;
  height: 250px;
}
/* .swiper-wrapper > div {
  margin: 5px;
}  */
</style>
